/* eslint-disable @typescript-eslint/no-non-null-assertion */
// Replaces planMapping. maybe
import { PolicyType } from '../models';
import { PlanNames } from './planNames';
import { stripePriceToPlanMap } from './pricingMaps';
export const DEFAULT_POLICY_LIMIT = 99; // 30 of each kind to stop customers going overboard
export const DEFAULT_GROUP_LIMIT = 30; // 30 of each kind to stop customers going overboard
export const DEFAULT_EMAIL_TEMPLATE_LIMIT = 20; // 15 email templates
export const BILLING_THRESHOLD_SMS_COUNT = 50; // 50 texts
/** I.e small or large plans */
export var PlanCategory;
(function (PlanCategory) {
    PlanCategory["Standard"] = "Standard";
    PlanCategory["Large"] = "Large";
})(PlanCategory || (PlanCategory = {}));
/** How we know which item is the core plan versus addon */
export var StripePriceType;
(function (StripePriceType) {
    StripePriceType["Core"] = "core";
    StripePriceType["Sms"] = "sms";
    // TODO: Other addons here, such as mail, calls etc
})(StripePriceType || (StripePriceType = {}));
const defaultPolicyLimits = {
    [PolicyType.DISCOUNT]: DEFAULT_POLICY_LIMIT,
    [PolicyType.LATE_FEE]: DEFAULT_POLICY_LIMIT,
    [PolicyType.REMINDER]: DEFAULT_POLICY_LIMIT,
    [PolicyType.SMS]: DEFAULT_POLICY_LIMIT,
    [PolicyType.STATEMENT_LATE_FEE]: DEFAULT_POLICY_LIMIT,
    [PolicyType.STATEMENT]: DEFAULT_POLICY_LIMIT,
    [PolicyType.ESCALATION]: DEFAULT_POLICY_LIMIT,
    [PolicyType.QUOTE_EMAIL]: DEFAULT_POLICY_LIMIT,
    [PolicyType.CONTACT_ESCALATION]: DEFAULT_POLICY_LIMIT,
    [PolicyType.PAYMENT_PLAN_REMINDER]: DEFAULT_POLICY_LIMIT,
    [PolicyType.ON_DEMAND_PLACEHOLDER]: DEFAULT_POLICY_LIMIT,
};
export const planMap = new Map([
    [PlanNames.Mini, {
            current: true,
            name: PlanNames.Mini,
            category: PlanCategory.Standard,
            features: {
                whitelabel: false,
                customDomain: false,
                webhooks: false,
                statementEmails: true,
                statementInterest: false,
                multicurrency: false,
                multiEntityReporting: false,
                userPermissions: false,
                paymentPlans: false,
            },
            limits: {
                policyTypes: defaultPolicyLimits,
                invoices: 50,
                accountingConnections: 1,
                customGroups: DEFAULT_GROUP_LIMIT,
                emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
            },
        }],
    [PlanNames.Starter, {
            current: true,
            name: PlanNames.Starter,
            category: PlanCategory.Standard,
            features: {
                whitelabel: false,
                customDomain: false,
                webhooks: false,
                statementEmails: true,
                statementInterest: false,
                multicurrency: false,
                multiEntityReporting: false,
                userPermissions: false,
                paymentPlans: false,
            },
            limits: {
                policyTypes: defaultPolicyLimits,
                invoices: 150,
                accountingConnections: 1,
                customGroups: DEFAULT_GROUP_LIMIT,
                emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
            },
        }],
    [PlanNames.Professional, {
            current: true,
            name: PlanNames.Professional,
            category: PlanCategory.Standard,
            features: {
                whitelabel: true,
                customDomain: true,
                webhooks: true,
                statementEmails: true,
                statementInterest: true,
                multicurrency: true,
                multiEntityReporting: true,
                userPermissions: true,
                paymentPlans: true,
            },
            limits: {
                policyTypes: defaultPolicyLimits,
                invoices: 300,
                accountingConnections: 3,
                customGroups: DEFAULT_GROUP_LIMIT,
                emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
            },
        }],
    [PlanNames.Multi, {
            current: true,
            name: PlanNames.Multi,
            category: PlanCategory.Standard,
            features: {
                whitelabel: true,
                customDomain: true,
                webhooks: true,
                statementEmails: true,
                statementInterest: true,
                multicurrency: true,
                multiEntityReporting: true,
                userPermissions: true,
                paymentPlans: true,
            },
            limits: {
                policyTypes: defaultPolicyLimits,
                invoices: 600,
                accountingConnections: 10,
                customGroups: DEFAULT_GROUP_LIMIT,
                emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
            },
        }],
    [PlanNames.MultiPlus, {
            current: true,
            name: PlanNames.MultiPlus,
            category: PlanCategory.Large,
            features: {
                whitelabel: true,
                customDomain: true,
                webhooks: true,
                statementEmails: true,
                statementInterest: true,
                multicurrency: true,
                multiEntityReporting: true,
                userPermissions: true,
                paymentPlans: true,
            },
            limits: {
                policyTypes: defaultPolicyLimits,
                invoices: 1000,
                accountingConnections: 20,
                customGroups: DEFAULT_GROUP_LIMIT,
                emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
            },
        }],
    [PlanNames.Multi3000, {
            current: true,
            name: PlanNames.Multi3000,
            category: PlanCategory.Large,
            features: {
                whitelabel: true,
                customDomain: true,
                webhooks: true,
                statementEmails: true,
                statementInterest: true,
                multicurrency: true,
                multiEntityReporting: true,
                userPermissions: true,
                paymentPlans: true,
            },
            limits: {
                policyTypes: defaultPolicyLimits,
                invoices: 3000,
                accountingConnections: 20,
                customGroups: DEFAULT_GROUP_LIMIT,
                emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
            },
        }],
]);
const legacyPlanMap = new Map([
    [PlanNames.LegacyLite, Object.assign(Object.assign({}, planMap.get(PlanNames.Mini)), { name: PlanNames.LegacyLite })], // Map old lite to mini
    [PlanNames.LegacyStarter, Object.assign(Object.assign({}, planMap.get(PlanNames.Starter)), { name: PlanNames.LegacyStarter })], // Map old starter to starter
    [PlanNames.LegacyStandard, Object.assign(Object.assign({}, planMap.get(PlanNames.Professional)), { name: PlanNames.LegacyStandard })], // Map old standard to professional
    [PlanNames.LegacyPro, Object.assign(Object.assign({}, planMap.get(PlanNames.Professional)), { name: PlanNames.LegacyPro })], // Map old pro to professional
    [PlanNames.LegacyUnlimited, Object.assign(Object.assign({}, planMap.get(PlanNames.Multi)), { name: PlanNames.LegacyUnlimited })], // Map old unlimited to multi
]);
export function getPlanFromPrice(priceId) {
    const planName = stripePriceToPlanMap[priceId];
    if (!planName) {
        throw new Error(`No plan found for price ${priceId}`);
    }
    const plan = planMap.get(planName) || legacyPlanMap.get(planName);
    if (!plan) {
        throw new Error(`No plan found for known price ${priceId}`);
    }
    return plan;
}
//# sourceMappingURL=planMap.js.map